import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'operationStatus'
})
export class OperationStatusPipe implements PipeTransform {

  transform(value: string): string | null {
    switch (value) {
      case 'created':
        return 'Creada';
      case 'pending':
        return 'Pendiente de pago';
      case 'in_process':
        return 'En proceso';
      case 'confirmed':
        return 'Confirmada';
      case 'failed':
        return 'Error';
      case 'refunded':
        return 'Reembolsado';
      case 'annulled':
        return 'Anulado';
      case 'cancelled':
        return 'Cancelada';
      case 'expired':
        return 'Expirada';
      case 'paid':
        return 'Pagada';
    }
    return value;
  }
}